import { render } from "./TableCurrency.vue?vue&type=template&id=56153bbc"
import script from "./TableCurrency.vue?vue&type=script&lang=js"
export * from "./TableCurrency.vue?vue&type=script&lang=js"

import "./TableCurrency.vue?vue&type=style&index=0&id=56153bbc&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__